import {
    type ConversationAttachmentsStore,
    type ConversationAttachmentsViewState,
} from './schema/conversationAttachmentsViewState';
import { createStore } from 'owa-satcheljs';
import type { MailboxInfo } from 'owa-client-types';
import { getAccountKeyForMailboxInfo } from 'owa-client-types';

// separate store per mailbox
const stores = new Map<string, ConversationAttachmentsStore>();

export function getStore(mailboxInfo: MailboxInfo): ConversationAttachmentsStore {
    const accountKey = getAccountKeyForMailboxInfo(mailboxInfo);
    const name = `${accountKey}_conversationAttachmentsStore`;
    let cachedStore = stores.get(name);
    if (!cachedStore) {
        const store = createConversationAttachmentsStore(name);
        stores.set(name, store);
        cachedStore = store;
    }

    return cachedStore;
}

function createConversationAttachmentsStore(name: string) {
    const initialStore: ConversationAttachmentsStore = {
        conversationAttachments: new Map<string, ConversationAttachmentsViewState>(),
    };
    /* eslint-disable-next-line owa-custom-rules/invoke-only-in-module-scope -- (https://aka.ms/OWALintWiki)
     * Baseline. DO NOT COPY AND PASTE!, this function can only be called in the module scope.
     *	> Function should only be invoked in module scope */
    return createStore<ConversationAttachmentsStore>(name, initialStore)();
}
